import { apiSlice } from "../api/apiSlice";

export const tasksApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTasks: builder.query({
      query: () => "/tasks",
    }),
    getTaskById: builder.query({
      query: (id) => `/tasks/${id}`,
    }),
    addTask: builder.mutation({
      query: (data) => ({
        url: "/tasks",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const task = await queryFulfilled;
          // add task cache pessimistically start
          dispatch(
            apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
              draft.push(task?.data);
            })
          );
          // add task cache pessimistically end
        } catch (err) {}
      },
    }),
    updateTaskStatus: builder.mutation({
      query: ({ id, status, data }) => ({
        url: `/tasks/${id}`,
        method: "PATCH",
        body: data,
      }),

      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        // optimistic cache update start
        const pathResult = dispatch(
          apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
            const draftTask = draft.find((t) => t.id == arg.id);
            draftTask.status = arg.status;
          })
        );
        // optimistic cache update end

        try {
          await queryFulfilled;
        } catch (err) {
          pathResult.undo();
        }
      },
    }),
    updateTask: builder.mutation({
      query: ({ id, data }) => ({
        url: `/tasks/${id}`,
        method: "PATCH",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const task = await queryFulfilled;
          // add task cache pessimistically start
          dispatch(
            apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
              const indexToUpdate = draft.find((t) => t.id == arg.id);
              indexToUpdate.taskName = task?.data?.taskName;
              indexToUpdate.teamMember = task?.data?.teamMember;
              indexToUpdate.project = task?.data?.project;
              indexToUpdate.deadline = task?.data?.deadline;
              indexToUpdate.status = task?.data?.status;
            })
          );
          // add task cache pessimistically end
        } catch (err) {}
      },
    }),
    deleteTask: builder.mutation({
      query: (id) => ({
        url: `/tasks/${id}`,
        method: "DELETE",
      }),

      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        // optimistic cache update start
        const pathResult = dispatch(
          apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
            const indexToRemove = draft.findIndex((t) => t.id === arg);
            if (indexToRemove !== -1) {
              draft.splice(indexToRemove, 1);
            }
          })
        );
        // optimistic cache update end

        try {
          await queryFulfilled;
        } catch (err) {
          pathResult.undo();
        }
      },
    }),
  }),
});

export const {
  useGetTasksQuery,
  useGetTaskByIdQuery,
  useAddTaskMutation,
  useUpdateTaskStatusMutation,
  useUpdateTaskMutation,
  useDeleteTaskMutation,
} = tasksApi;
